import {SET_TAP_BAR_DATA} from './actionTypes';

export const setTapBarData = (data) => (
	{
		type: SET_TAP_BAR_DATA,
		payload: data
	}
);
